import { Component, Output, Injector, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationActions } from '../../actions/application.actions';

@Component({
  selector: 'md-recommendation-disclaimer-modal',
  template: require('./recommendation-disclaimer-modal.component.html'),
  styles: [require('./recommendation-disclaimer-modal.component.scss')]
})

export class RecommendationDisclaimerModalComponent {
  @Output() closeEmitter = new EventEmitter();

  constructor(injector: Injector,
    appActions: ApplicationActions,
    router: Router) {
    this.appActions = appActions;
    this.router = router;
  }

  // if isUserSelectedPortfolio set to TRUE by this modal - invoking function has to
  // set redux store SelectedPortfolioTier to what portfolio user has chosen
  confirm(event: boolean) {
    if (event) {
      this.appActions.setData('goalSession.isUserSelectedPortfolio', true);
      // Close emitter is intentionally not called because of timing issues
      this.router.navigateByUrl('/recommendation', { queryParamsHandling: 'preserve' });
      // setTimeout(() => this.closeEmitter.emit(), 100);
    } else {
      this.closeEmitter.emit();
    }
  }
}
